import RestList from 'containers/rest/List';
import React, { useEffect } from 'react';
import { DynamicObjectType, FilterFromUrlResponseType } from 'types/commons';
import ActiveStatus from '../components/ActiveStatus';
import { Link, useNavigate } from 'react-router-dom';
import Breadcrumb from 'components/commons/Breadcrumb';
import { TFilterItem } from 'components/rest/Filter/FilterRow';
import { useDispatch } from '@redux';
import crudActions from '@redux/crudActions';

const breadcrumbs = [
  {
    title: 'Mores',
    href: '#',
  },
  {
    title: 'Role Permissions',
  },
];

const RolePermissionsList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const restInitialFilter: FilterFromUrlResponseType = {
    join: [''],
    filters: [
      // {
      //   condition: 'and',
      //   key: 'role',
      //   operator: 'ne',
      //   value: 'custom',
      // },
    ],
  };

  const columns = [
    {
      name: 'name',
      title: 'Role',
      isDefault: true,
      render: (dt, rc: DynamicObjectType) => (
        <Link className="text-highlight" to={`/rolePermissions/${rc.id}/edit`}>
          {dt}
        </Link>
      ),
    },
    {
      name: 'isActive',
      title: 'Status',
      render: (dt, rc: DynamicObjectType) => (
        <ActiveStatus source="isActive" record={rc} />
      ),
      isDefault: true,
    },
  ];

  const filters: TFilterItem[] = [
    {
      key: 'createdAt',
      label: 'Created time',
      isDatePicker: true,
    },
    {
      key: 'createdBy.name',
      label: 'Created By',
    },
    {
      key: 'isActive',
      label: 'Status',
      dataSource: [
        { value: 'true', label: 'Active' },
        { value: 'false', label: 'In Active' },
      ],
    },
  ];

  useEffect(() => {
    dispatch(crudActions['roles'].clearCurrent());
  }, [window.location.pathname]);

  return (
    <>
      <div className="mb-5">
        <Breadcrumb items={breadcrumbs} />
      </div>
      <RestList
        initialFilter={restInitialFilter}
        columns={columns}
        model="roles"
        hasSearch
        hasImport={false}
        hasExport={false}
        hasFilter
        hasOnlyFilter
        searchKeys={['name']}
        placeholderInputSearch="Search by name"
        gotoCreatePage={() => navigate('/rolePermissions/create')}
        filters={filters}
      />
    </>
  );
};

export default RolePermissionsList;
